import React, {useCallback, useMemo} from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {useSearchMgrInstance, useSetUI} from 'coreHooks';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import {useCategoryContext} from 'brand/app/pages/category/context/CategoryContext';
import Button from 'brandComponents/Button';
import Icon from 'brandComponents/Icon';
import Typography from 'brandComponents/Typography';

import messages from './messages';

import styles from './OpenFiltersButton.module.scss';

const OpenFiltersButton = () => {
	const {managerRepository} = useGeneralProvider();
	const intl = useIntl();
	const setUI = useSetUI();
	const {searchType, searchInstanceKey} = useCategoryContext(true) || {};
	const searchMgr = useSearchMgrInstance({
		searchType,
		key: searchInstanceKey
	});
	const searchModel = searchMgr.getStoredSearchModel();

	const selectedFilters = useMemo(() => {
		return searchModel?.getSelectedRefinementsValuesModels().length || 0;
	}, [searchModel]);

	const handleOpenFilters = useCallback(() => {
		setUI.setSearchConfig(searchInstanceKey, searchType);
		managerRepository.getFlyoutsMgr().openFlyout('filters');
	}, [searchInstanceKey, searchType]);

	return (
		<Button classNames={styles['open-filters-button']} variant="anything" onClick={handleOpenFilters}>
			<Icon name="filter" width={20} height={20} />
			<Typography variant="span" classNames={cn(styles['open-filters-button__label'], 'open-filters-button__label')}>
				{intl.formatMessage(messages.filter, {count: selectedFilters})}
			</Typography>
		</Button>
	);
};

export default OpenFiltersButton;
